import React, { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { css } from '@emotion/core';
import i18next from 'i18next';
import { neutral500 } from '@fever/ui';

const OtpCountdownTimer = ({
    initialTime = 300, // 5 minutes
    onExpired = () => {},
    onTick = () => {}
}) => {
    const [timeLeft, setTimeLeft] = useState(initialTime);

    useEffect(() => {
        if (timeLeft <= 0) {
            onExpired();
            return;
        }

        const timer = setInterval(() => {
            setTimeLeft(prev => {
                const newTime = prev - 1;
                if (newTime <= 0) {
                    onExpired();
                    return 0;
                }
                onTick(newTime);
                return newTime;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [timeLeft, onExpired, onTick]);

    const formatTime = seconds => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    if (timeLeft <= 0) {
        return null;
    }

    return (
        <div css={containerStyle}>
            <Typography variant="caption" css={timerTextStyle} data-testid="countdown-timer">
                {i18next.t('label.remaining_time')}: {formatTime(timeLeft)}
            </Typography>
        </div>
    );
};

const containerStyle = css`
    display: flex;
    justify-content: center;
    margin: 8px 0;
`;

const timerTextStyle = css`
    color: ${neutral500};
    font-size: 12px;
    font-weight: 400;
`;

export default OtpCountdownTimer;
